// import React, { useState } from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMHTMLEditor from "src/components/UI/atoms/formFields/ATMHTMLEditor/ATMHTMLEditor";
import ATMCheckbox from "src/components/UI/atoms/formFields/ATMCheckbox/ATMCheckbox";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import ATMFilePickerWrapper from "src/components/UI/atoms/formFields/ATMFileUploader/ATMFileUploaderWrapper";
import { BlogFormValues } from "src/models/Blog.model";

type Props = {
  formikProps: FormikProps<BlogFormValues>;
  // onClose: () => void;
  editorValue?: string;
  formType: "Add" | "Edit";
  setSaveNextChecked?: any;
  saveNextChecked?: any;
};

const BlogForm = ({
  formikProps,
  // onClose,
  editorValue,
  formType,
  setSaveNextChecked,
  saveNextChecked,
}: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
  return (
    <div className="flex flex-col flex-1 gap-4 p-4 overflow-hidden">
      <div className="flex items-center justify-between h-fit">
        <div className="text-xl font-medium">
          {formType === "Add" ? "Add Blog" : "Update Blog"}
        </div>
      </div>
      <div className="flex flex-col gap-4 overflow-scroll">
        {/* blog title */}
        <ATMTextField
          name="title"
          value={values?.title}
          onChange={(e) => setFieldValue("title", e.target.value)}
          label="Blog Title"
          placeholder="Enter blog Title"
          onBlur={handleBlur}
        />
        {/* banner image */}
        <div className="w-fit">
          <ATMFilePickerWrapper
            name="bannerImage"
            label="Banner Image"
            placeholder="select file"
            selectedFile={values?.bannerImage}
            onSelect={(imgUrl) => {
              setFieldValue("bannerImage", imgUrl);
            }}
          />
        </div>
        {/* content */}
        <ATMHTMLEditor
          name="description"
          key={editorValue}
          label="Content"
          value={values?.description}
          placeholder="Write here...."
          onChange={(newValue: any) => {
            setFieldValue("description", newValue);
          }}
        />
      </div>

      <div className="h-fit">
        {formType === "Add" && (
          <div>
            <ATMCheckbox
              label="Save and Next"
              checked={saveNextChecked}
              onChange={(checked) => {
                setSaveNextChecked(checked);
              }}
            />
          </div>
        )}
        <div>
          <ATMLoadingButton isLoading={isSubmitting} type="submit">
            Save
          </ATMLoadingButton>
        </div>
      </div>
    </div>
  );
};

export default BlogForm;
